document.addEventListener("DOMContentLoaded", function(){
    // Menu Toggle Animation
    document.getElementById('nav-toggle').onclick = function(){
        document.getElementById("nav-content").classList.toggle("max-h-1000")
    }
})
